import { TourPlacementEnum } from 'components/tour/types/model-tour'
import { buildTourSteps } from 'components/tour/util/buildTourSteps'

export enum CidadaoTourIdEnum {
  PAGE_TITLE = 'tour-cidadao-page-title',
  FORM_CPF = 'tour-cidadao-form-cpf',
  FORM_DADOS_PESSOAIS = 'tour-cidadao-form-dados-pessoais',
  FORM_EQUIPE_REFERENCIA = 'tour-cidadao-form-equipe-referencia',
  FORM_TERRITORIO = 'tour-cidadao-form-territorio',
  FORM_SOCIODEMOGRAFICAS = 'tour-cidadao-form-sociodemograficas',
  CADSUS_BUTTON = 'tour-cidadao-cadsus-button',
  FORM_CONFIRMAR = 'tour-cidadao-form-confirmar',
}

interface CidadaoTourStepsFlags {
  isModoSimplificado: boolean
  isNovoCadastro: boolean
  isCadsusButtonVisible: boolean
  includePageTitle?: boolean
}

export const buildCidadaoTourSteps = ({
  isModoSimplificado,
  isNovoCadastro,
  isCadsusButtonVisible,
  includePageTitle = true,
}: CidadaoTourStepsFlags) =>
  buildTourSteps([
    {
      id: CidadaoTourIdEnum.PAGE_TITLE,
      title: 'O antigo módulo do cidadão evoluiu e agora se chama Cadastro Individual!',
      content: 'Ele passa a centralizar a gestão dos cadastros individuais, eliminando a necessidade de usar o CDS.',
      placement: TourPlacementEnum.BOTTOM,
      spotlightPadding: 2,
      when: includePageTitle,
    },
    {
      id: CidadaoTourIdEnum.FORM_CPF,
      title: 'O CPF agora é o identificador principal!',
      content:
        'Isso garante maior consistência nos registros e evita duplicidades. Caso o cidadão não possua CPF, uma justificativa deverá ser informada.',
      placement: TourPlacementEnum.BOTTOM,
    },
    {
      id: CidadaoTourIdEnum.FORM_DADOS_PESSOAIS,
      title: 'Informações exatas podem ajudar!',
      content:
        'Ao informar corretamente os dados de identificação, o sistema irá automaticamente verificar se o cadastro já existe na base local e, se sim, sugerir uma atualização do mesmo, evitando duplicidade.',
      placement: TourPlacementEnum.LEFT_START,
    },
    {
      id: CidadaoTourIdEnum.FORM_EQUIPE_REFERENCIA,
      title: 'Vinculação mais simples!',
      content:
        'O que antes era informado no cabeçalho das fichas, agora é informado aqui. Essa vinculação do cadastro pode ser atualizada quando necessário.',
      placement: TourPlacementEnum.LEFT_START,
      when: !isModoSimplificado,
    },
    {
      id: CidadaoTourIdEnum.FORM_TERRITORIO,
      title: 'Melhor organização!',
      content:
        'Os dados da família foram agrupados com os de vinculação ao território para facilitar a formação de cadastros completos.',
      placement: TourPlacementEnum.LEFT_END,
      when: !isModoSimplificado,
    },
    {
      id: CidadaoTourIdEnum.FORM_SOCIODEMOGRAFICAS,
      title: 'Ficou mais fácil registrar tudo!',
      content:
        'Os campos que só existiam na Ficha de Cadastro Individual podem ser preenchidos nestas seções agrupadoras.',
      placement: TourPlacementEnum.BOTTOM_START,
      when: !isModoSimplificado,
    },
    {
      id: CidadaoTourIdEnum.CADSUS_BUTTON,
      title: 'Utilize dados da base nacional!',
      content:
        'O sistema compara as informações locais com a base nacional e substitui no formulário aquelas que estiverem diferentes. As alterações não são salvas automaticamente: revise e salve o cadastro para confirmá-las.',
      placement: TourPlacementEnum.BOTTOM,
      when: !isNovoCadastro && isCadsusButtonVisible,
    },
    {
      id: CidadaoTourIdEnum.FORM_CONFIRMAR,
      title: 'Tudo pronto!',
      content:
        'Ao salvar, o sistema produzirá uma ficha de cadastro individual automaticamente, que será contabilizada nos relatórios e indicadores conforme as políticas já vigentes.',
      placement: TourPlacementEnum.TOP,
    },
  ])
